import { StyledFlex, StyledMargin, UncontrolledCheckbox } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../translations';

import { useShowRemovedMedicalInformationState } from './MedicalInformationShowRemovedCheckbox.hooks';

export const MedicalInformationShowRemovedCheckbox = (): JSX.Element => {
   const [showRemoved, setShowRemoved] = useShowRemovedMedicalInformationState();

   return (
      <StyledMargin top={2} right={18}>
         <StyledFlex justifyContent={'flex-end'} width={'100%'}>
            <UncontrolledCheckbox
               testId={'removedMedicalInformationVisibility'}
               name={'removedMedicalInformationVisibility'}
               id={'removedMedicalInformationVisibility'}
               label={patientMedicalInformationTranslationKeys.showRemoved}
               selected={Boolean(showRemoved)}
               onSelectionChange={setShowRemoved}
            />
         </StyledFlex>
      </StyledMargin>
   );
};
